/* eslint-disable func-names */
/* eslint-disable eqeqeq */
/* eslint-disable no-multi-assign */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-param-reassign */

import emogjiDissatisfiedVery from '../../../assets/emojis/Emotion 5.png';
import emogjiDissatisfied from '../../../assets/emojis/Emotion 4.png';
import emogjiNeutral from '../../../assets/emojis/Emotion 3.png';
import emogjiSatisfied from '../../../assets/emojis/Emotion 2.png';
import emogjiSatisfiedVery from '../../../assets/emojis/Emotion 1.png';
import './eb-emotion-ratings2.js';

export const EbEmoticons2: any = (SurveyKo: any) => {
  return {
    name: 'funnyemotionsratings',
    title: 'Emotions Ratings',
    iconName: 'icon-emotionsratings',
    widgetIsLoaded() {
      return typeof $ == 'function';
    },
    defaultJSON: {
      choices: [1, 2, 3, 4, 5],
    },
    isFit(question: any) {
      return question.getType() == 'funnyemotionsratings';
    },
    isDefaultRender: false,
    htmlTemplate: "<div style='height: 55px'></div>",
    activatedByChanged(activatedBy: any) {
      SurveyKo.JsonObject.metaData.addClass(
        'funnyemotionsratings',
        [
          {
            name: 'hasOther',
            visible: false,
          },
          {
            name: 'otherText',
            visible: false,
          },
          {
            name: 'optionsCaption',
            visible: false,
          },
          {
            name: 'otherErrorText',
            visible: false,
          },
          {
            name: 'storeOthersAsComment',
            visible: false,
          },
          {
            name: 'renderAs',
            visible: false,
          },
        ],
        null,
        'dropdown',
      );
      SurveyKo.JsonObject.metaData.addProperties('funnyemotionsratings', [
        {
          name: 'emotions:itemvalues',
          category: 'emotions',
          categoryIndex: 1,
          default: [
            emogjiDissatisfiedVery,
            emogjiDissatisfied,
            emogjiNeutral,
            emogjiSatisfied,
            emogjiSatisfiedVery,
          ],
        },
        {
          name: 'emotionSize:number',
          category: 'emotions',
          default: 60,
        },
        {
          name: 'emotionsCount:number',
          category: 'emotions',
          default: 5,
        },
        {
          name: 'bgEmotion',
          category: 'emotions',
          default: emogjiNeutral,
        },
        {
          name: 'emotionColor',
          category: 'emotions',
          default: '#FF0066',
        },
      ]);
    },
    afterRender(question: any, el: any) {
      const emotionsArray = [
        emogjiDissatisfiedVery,
        emogjiDissatisfied,
        emogjiNeutral,
        emogjiSatisfied,
        emogjiSatisfiedVery,
      ];

      const questionSorted = {
        ...question,
        choices: question.choices.sort((a: any, b: any) => {
          if (a.value > b.value) return -1;
          return a.value < b.value ? 1 : 0;
        }),
      };

      const options = {
        bgEmotion: emogjiNeutral,
        emotions: emotionsArray,
        initialRating: question.value,
        color: question.emotionColor,
        count: 5,
        question: questionSorted,
        onUpdate: (value: any) => {
          question.value = value;
        },
      };

      initWidget();
      question.readOnlyChangedCallback = initWidget;

      function initWidget() {
        el.innerHTML = `<div id="ebemojis"><input id='selectedItem' type='hidden' class='' name='' value='' /></div>`;
        $(el).off();

        (<any>$(el)).find('div').funnyemotionsratings(options);
      }
    },
    willUnmount(question: any, el: any) {
      el.innerHTML = null;
      $(el).off();
      question.readOnlyChangedCallback = null;
      question.valueChangedCallback = null;
    },
    pdfQuestionType: 'dropdown',
  };
};
